import { useEffect, useRef, useState } from 'react';

const NOTICE_BEFORE_MS = 5 * 60 * 1000;
// setTimeout overflows past ~24.8 days - a cap that far out needs no timer yet.
const MAX_TIMER_MS = 2 ** 31 - 1;

// MaxTokenValidity is a hard cap from login that activity can't extend, so instead of
// a "stay signed in" prompt this only gives notice shortly before it hits, then logs
// out at that moment rather than letting the next click run into a 401.
// expiresAt is epoch millis (from /me), null when the session has no cap.
export function useSessionExpiry(loginId, expiresAt, onExpire) {
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;
  const [noticeShown, setNoticeShown] = useState(false);

  useEffect(() => {
    setNoticeShown(false);
    if (!loginId || !expiresAt) return;

    const untilExpiry = expiresAt - Date.now();
    if (untilExpiry > MAX_TIMER_MS) return;

    const noticeId = setTimeout(() => setNoticeShown(true), Math.max(0, untilExpiry - NOTICE_BEFORE_MS));
    const expireId = setTimeout(() => onExpireRef.current(), Math.max(0, untilExpiry));
    return () => {
      clearTimeout(noticeId);
      clearTimeout(expireId);
    };
  }, [loginId, expiresAt]);

  return { noticeShown, dismissNotice: () => setNoticeShown(false) };
}
